import {
    TEAM_FAILURE,
    TEAM_REQUEST,
    TEAM_SUCCESS,
    TEAM_POST_SUCCESS, TEAM_DELETE_SUCCESS,
    TEAM_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
    /*
     * WHICH competition `data` holds, or null for every team.
     *
     * The whole collection is 537 KB and both readers — `/applications` and
     * `/competitions` — show exactly one competition's, so each now asks for
     * one. `isFetched` on its own would then tell the next screen the list is
     * complete when it holds a single competition. Same contract the
     * applications and participants slices already use.
     */
    fetchedCompetition: null,
};

export const listReducer = (state = initialState, action) => {
    const { type, data, team } = action;
    switch (type) {
        case TEAM_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== team)
            return {
                ...state,
                data: [...newData]
            }
        }

        case TEAM_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, team]
            }
        }

        // Was previously a silent no-op — the action fired but no case
        // existed for it, so ApplicationInfo.js worked around the gap with
        // a dispatch(fetchTeams()) full-list refetch after every edit
        // (front/docs/SPA_ARCHITECTURE_AUDIT.md finding R2). Merged in
        // place (map, not filter+append) so editing one team never
        // reorders the others.
        case TEAM_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === team.id ? team : d)
            }
        }

        case TEAM_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            fetchedCompetition: action.competition || null,
            data: preserveArrayReference(state.data, data),
        }}

        case TEAM_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case TEAM_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
